<!-- 一页解读:行情数据 -->
<template>
  <div class="box">
    <div class="desc-box">
      <p class="module-title">解读概览</p>
      <div class="read-row" v-for="info in readInfo" :key="info.key">
        <template v-if="info.key !== 'interpretImg'">
          <div class="title-row">
            <img v-if="info.icon" class="icon" :src="info.icon" />
            <div class="title-box">
              <div class="underline" />
              <p class="title-text">{{ info.title }}</p>
            </div>
          </div>
          <p class="desc-text">{{ info.desc }}</p>
        </template>
        <img v-else-if="info.desc" :src="info.desc" width="332px" />
      </div>
      <p v-if="readUpdateTime" class="update-time">更新时间：{{ readUpdateTime }}</p>
    </div>
    <p class="risk-tip">{{ riskText }}</p>
  </div>
</template>

<script>
export default {
  props: {
    fundCode: String,
    mergeData: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {};
  },

  computed: {
    readInfo() {
      console.log('aaaaaaaa', this.mergeData?.readInfo);
      return this.mergeData?.readInfo || [];
    },

    riskText() {
      const manager = this.mergeData?.manager ?? '--';
      return `本材料内容由【${manager}】提供并对内容的合法合规性独立承担法律责任。本材料中相关基金的基金销售服务由上海天天基金销售有限公司提供。上海天天基金销售有限公司对本材料的合法合规性不承担任何责任。过往业绩不预示未来表现，市场有风险，投资需谨慎。`;
    },
    readUpdateTime() {
      return this.mergeData?.readUpdateTime ?? '';
    },
  },

  methods: {},
};
</script>

<style scoped>
.update-time {
  display: flex;
  flex-direction: column;
  text-align: right;
  font-size: 24px;
  color: #cecece;
  margin-top: 16px;
  align-self: flex-end;
}
.title-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.read-row {
  margin-top: 40px;
}
.icon {
  width: 29px;
  height: 29px;
  margin-right: 20px;
}
.module-title {
  font-family: PingFangSC-Medium;
  font-size: 32px;
  color: #000000;
  letter-spacing: 0;
  line-height: 32px;
  font-weight: bold;
}
.desc-text {
  margin: 11px 0 0 44px;
  font-family: PingFangSC-Regular;
  font-size: 26px;
  color: #666666;
  letter-spacing: 0;
  line-height: 40px;
}
.title-text {
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #31180e;
  font-weight: 400;
  z-index: 1;
}
.title-box {
  display: flex;
  height: 46px;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
}
.underline {
  background: #fcf1e4;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  z-index: 0;
}
.desc-box {
  width: 100%;
  padding: 38px 20px 24px 20px;
  background-color: #ffffff;
  border-radius: 17px;
}
.box {
  margin-left: 24px;
  margin-right: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  margin-top: 24px;
}

.risk-tip {
  font-family: PingFangSC-Regular;
  font-size: 22px;
  color: #999999;
  margin-top: 24px;
  margin-bottom: 200px;
}

.text {
  font-size: 30px;
  color: #666666;
}
</style>
